/** Api key for the open weather map */
export const key = '8f10d0c12d0872124c79bd426d5d1003';
/** Api url for the open weather map */
export const api = 'https://api.openweathermap.org/data/2.5';
/** Image url for the weather condition */
export const imageUrl = 'http://openweathermap.org/img/w';
